
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirefea6"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirefea6"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("27Lyk", function(module, exports) {

$parcel$export(module.exports, "register", () => $18c11f3350a906ea$export$6503ec6e8aabbaf, (v) => $18c11f3350a906ea$export$6503ec6e8aabbaf = v);
var $18c11f3350a906ea$export$6503ec6e8aabbaf;
var $18c11f3350a906ea$export$f7ad0328861e2f03;
"use strict";
var $18c11f3350a906ea$var$mapping = new Map();
function $18c11f3350a906ea$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$18c11f3350a906ea$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $18c11f3350a906ea$var$resolve(id) {
    var resolved = $18c11f3350a906ea$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$18c11f3350a906ea$export$6503ec6e8aabbaf = $18c11f3350a906ea$var$register;
$18c11f3350a906ea$export$f7ad0328861e2f03 = $18c11f3350a906ea$var$resolve;

});

parcelRegister("8tLg9", function(module, exports) {
module.exports = new URL("2k_stars_milky_way.724715d3.jpg", import.meta.url).toString();

});

parcelRegister("6dVhZ", function(module, exports) {
module.exports = new URL("2k_venus_atmosphere.6b67833a.jpg", import.meta.url).toString();

});

parcelRegister("bneSh", function(module, exports) {
module.exports = new URL("RS3_EarthC.aaeaa98f.jpg", import.meta.url).toString();

});

parcelRegister("boFjS", function(module, exports) {
module.exports = new URL("2k_jupiter.6180ba4a.jpg", import.meta.url).toString();

});

parcelRegister("3fSvu", function(module, exports) {
module.exports = new URL("2k_uranus.d1e141cb.jpg", import.meta.url).toString();

});

parcelRegister("cri0F", function(module, exports) {
module.exports = new URL("2k_neptune.5fc74549.jpg", import.meta.url).toString();

});

parcelRegister("3j72e", function(module, exports) {
module.exports = new URL("th.097e04fb.jpeg", import.meta.url).toString();

});

parcelRegister("7Hsmk", function(module, exports) {
module.exports = new URL("2k_moon.7ce750a3.jpg", import.meta.url).toString();

});

parcelRegister("lkuI6", function(module, exports) {
module.exports = new URL("2k_sun.defafe91.jpg", import.meta.url).toString();

});

parcelRegister("afWdh", function(module, exports) {
module.exports = new URL("2k_mercury.42e2b735.jpg", import.meta.url).toString();

});

parcelRegister("21K3A", function(module, exports) {
module.exports = new URL("2k_mars.6e9645ec.jpg", import.meta.url).toString();

});

parcelRegister("4qH3O", function(module, exports) {
module.exports = new URL("2k_saturn.024c2f02.jpg", import.meta.url).toString();

});

parcelRegister("8vFPr", function(module, exports) {
module.exports = new URL("2k_saturn_ring_alpha.d9c19af5.png", import.meta.url).toString();

});

var $d276f740681bf622$exports = {};

(parcelRequire("27Lyk")).register(new URL("", import.meta.url).toString(), JSON.parse('["eF8Sb","hazardous-neo.72e2990d.js","kkm0a","2k_stars_milky_way.724715d3.jpg","kYCeB","2k_venus_atmosphere.6b67833a.jpg","ko2HD","RS3_EarthC.aaeaa98f.jpg","bcu87","2k_jupiter.6180ba4a.jpg","hxmPk","2k_uranus.d1e141cb.jpg","9alQm","2k_neptune.5fc74549.jpg","8Qzke","th.097e04fb.jpeg","hDmsS","2k_moon.7ce750a3.jpg","dB8VS","2k_sun.defafe91.jpg","g3ADe","2k_mercury.42e2b735.jpg","lA6ca","2k_mars.6e9645ec.jpg","3NBD5","2k_saturn.024c2f02.jpg","gkBSn","2k_saturn_ring_alpha.d9c19af5.png","gitrq","Solar System.8b519564.js"]'));


var $ilwiq = parcelRequire("ilwiq");

var $5Rd1x = parcelRequire("5Rd1x");
parcelRequire("8tLg9");
parcelRequire("lkuI6");
parcelRequire("afWdh");
parcelRequire("6dVhZ");
parcelRequire("21K3A");

var $bneSh = parcelRequire("bneSh");
parcelRequire("boFjS");
parcelRequire("4qH3O");
parcelRequire("8vFPr");

var $3fSvu = parcelRequire("3fSvu");
parcelRequire("cri0F");
parcelRequire("3j72e");

var $7Hsmk = parcelRequire("7Hsmk");
const $f39bf4bcdcb148e5$var$renderer = new $ilwiq.WebGLRenderer();
$f39bf4bcdcb148e5$var$renderer.setSize(window.innerWidth, window.innerHeight);
document.body.appendChild($f39bf4bcdcb148e5$var$renderer.domElement);
const $f39bf4bcdcb148e5$var$scene = new $ilwiq.Scene();
const $f39bf4bcdcb148e5$var$camera = new $ilwiq.PerspectiveCamera(65, window.innerWidth / window.innerHeight, 0.1, 1000);
const $f39bf4bcdcb148e5$var$orbit = new (0, $5Rd1x.OrbitControls)($f39bf4bcdcb148e5$var$camera, $f39bf4bcdcb148e5$var$renderer.domElement);
$f39bf4bcdcb148e5$var$orbit.update();
const $f39bf4bcdcb148e5$var$ambientLight = new $ilwiq.AmbientLight(0x333333);
$f39bf4bcdcb148e5$var$scene.add($f39bf4bcdcb148e5$var$ambientLight);
const $f39bf4bcdcb148e5$var$cubeTextureLoad = new $ilwiq.CubeTextureLoader();
$f39bf4bcdcb148e5$var$scene.background = $f39bf4bcdcb148e5$var$cubeTextureLoad.load([
    (0, (/*@__PURE__*/$parcel$interopDefault($3fSvu)))
]);
const $f39bf4bcdcb148e5$var$textureLoader = new $ilwiq.TextureLoader();
$f39bf4bcdcb148e5$var$camera.position.z = 300;
//earth
const $f39bf4bcdcb148e5$var$earthGeo = new $ilwiq.SphereGeometry(20, 30, 30);
const $f39bf4bcdcb148e5$var$earthMat = new $ilwiq.MeshBasicMaterial({
    map: $f39bf4bcdcb148e5$var$textureLoader.load((0, (/*@__PURE__*/$parcel$interopDefault($bneSh))))
});
const $f39bf4bcdcb148e5$var$earth = new $ilwiq.Mesh($f39bf4bcdcb148e5$var$earthGeo, $f39bf4bcdcb148e5$var$earthMat);
$f39bf4bcdcb148e5$var$scene.add($f39bf4bcdcb148e5$var$earth);
//moon
const $f39bf4bcdcb148e5$var$moonGeo = new $ilwiq.SphereGeometry(4.6, 16, 16);
const $f39bf4bcdcb148e5$var$moonMat = new $ilwiq.MeshBasicMaterial({
    map: $f39bf4bcdcb148e5$var$textureLoader.load((0, (/*@__PURE__*/$parcel$interopDefault($7Hsmk))))
});
const $f39bf4bcdcb148e5$var$moon = new $ilwiq.Mesh($f39bf4bcdcb148e5$var$moonGeo, $f39bf4bcdcb148e5$var$moonMat);
//scene.add
const $f39bf4bcdcb148e5$var$moonObj = new $ilwiq.Object3D();
$f39bf4bcdcb148e5$var$moonObj.add($f39bf4bcdcb148e5$var$moon);
$f39bf4bcdcb148e5$var$scene.add($f39bf4bcdcb148e5$var$moonObj);
$f39bf4bcdcb148e5$var$moon.position.x = 38;
$f39bf4bcdcb148e5$var$moon.position.y = 20;
//asteroid
const $f39bf4bcdcb148e5$var$asteroidGeo = new $ilwiq.SphereGeometry(1, 5, 7);
const $f39bf4bcdcb148e5$var$asteroidMat = new $ilwiq.MeshBasicMaterial({
    map: $f39bf4bcdcb148e5$var$textureLoader.load((0, (/*@__PURE__*/$parcel$interopDefault($7Hsmk))))
});
const $f39bf4bcdcb148e5$var$asteroid = new $ilwiq.Mesh($f39bf4bcdcb148e5$var$asteroidGeo, $f39bf4bcdcb148e5$var$asteroidMat);
$f39bf4bcdcb148e5$var$scene.add($f39bf4bcdcb148e5$var$asteroid);
$f39bf4bcdcb148e5$var$asteroid.position.x = 180;
// Meteor trails (simple line representing meteors)
const $f39bf4bcdcb148e5$var$meteorGeometry = new $ilwiq.CylinderGeometry(1, 0.001, 25, 8);
const $f39bf4bcdcb148e5$var$meteorMaterial = new $ilwiq.MeshBasicMaterial({
    color: 0xfffff,
    transparent: true,
    opacity: 0.5
});
const $f39bf4bcdcb148e5$var$meteor = new $ilwiq.Mesh($f39bf4bcdcb148e5$var$meteorGeometry, $f39bf4bcdcb148e5$var$meteorMaterial);
$f39bf4bcdcb148e5$var$scene.add($f39bf4bcdcb148e5$var$meteor);
$f39bf4bcdcb148e5$var$meteor.position.z = -11;
$f39bf4bcdcb148e5$var$meteor.position.y = -4.7;
$f39bf4bcdcb148e5$var$meteor.position.x = 180;
$f39bf4bcdcb148e5$var$meteor.rotateX(20);
//asteroid1
const $f39bf4bcdcb148e5$var$asteroidGeo1 = new $ilwiq.SphereGeometry(1, 1, 7);
const $f39bf4bcdcb148e5$var$asteroidMat1 = new $ilwiq.MeshBasicMaterial({
    map: $f39bf4bcdcb148e5$var$textureLoader.load((0, (/*@__PURE__*/$parcel$interopDefault($7Hsmk))))
});
const $f39bf4bcdcb148e5$var$asteroid1 = new $ilwiq.Mesh($f39bf4bcdcb148e5$var$asteroidGeo1, $f39bf4bcdcb148e5$var$asteroidMat1);
$f39bf4bcdcb148e5$var$scene.add($f39bf4bcdcb148e5$var$asteroid1);
$f39bf4bcdcb148e5$var$asteroid1.position.x = -180;
// Meteor trails (simple line representing meteors)
const $f39bf4bcdcb148e5$var$meteorGeometry1 = new $ilwiq.CylinderGeometry(1, 0.001, 25, 8);
const $f39bf4bcdcb148e5$var$meteorMaterial1 = new $ilwiq.MeshBasicMaterial({
    color: 0xfffff,
    transparent: true,
    opacity: 0.5
});
const $f39bf4bcdcb148e5$var$meteor1 = new $ilwiq.Mesh($f39bf4bcdcb148e5$var$meteorGeometry1, $f39bf4bcdcb148e5$var$meteorMaterial1);
$f39bf4bcdcb148e5$var$scene.add($f39bf4bcdcb148e5$var$meteor1);
$f39bf4bcdcb148e5$var$meteor1.position.z = 10;
$f39bf4bcdcb148e5$var$meteor1.position.y = 4.5;
$f39bf4bcdcb148e5$var$meteor1.position.x = -187;
$f39bf4bcdcb148e5$var$meteor1.rotateX(20);
$f39bf4bcdcb148e5$var$meteor1.rotateZ(10);
//asteroid2
const $f39bf4bcdcb148e5$var$asteroidGeo2 = new $ilwiq.SphereGeometry(1, 13, 7);
const $f39bf4bcdcb148e5$var$asteroidMat2 = new $ilwiq.MeshBasicMaterial({
    map: $f39bf4bcdcb148e5$var$textureLoader.load((0, (/*@__PURE__*/$parcel$interopDefault($7Hsmk))))
});
const $f39bf4bcdcb148e5$var$asteroid2 = new $ilwiq.Mesh($f39bf4bcdcb148e5$var$asteroidGeo2, $f39bf4bcdcb148e5$var$asteroidMat2);
$f39bf4bcdcb148e5$var$scene.add($f39bf4bcdcb148e5$var$asteroid2);
$f39bf4bcdcb148e5$var$asteroid2.position.z = -180;
// Meteor trails (simple line representing meteors)
const $f39bf4bcdcb148e5$var$meteorGeometry2 = new $ilwiq.CylinderGeometry(1, 0.001, 25, 8);
const $f39bf4bcdcb148e5$var$meteorMaterial2 = new $ilwiq.MeshBasicMaterial({
    color: 0xfffff,
    transparent: true,
    opacity: 0.5
});
const $f39bf4bcdcb148e5$var$meteor2 = new $ilwiq.Mesh($f39bf4bcdcb148e5$var$meteorGeometry2, $f39bf4bcdcb148e5$var$meteorMaterial2);
$f39bf4bcdcb148e5$var$scene.add($f39bf4bcdcb148e5$var$meteor2);
$f39bf4bcdcb148e5$var$meteor2.position.y = -5.5;
$f39bf4bcdcb148e5$var$meteor2.position.z = -191;
$f39bf4bcdcb148e5$var$meteor2.rotateX(20);
function $f39bf4bcdcb148e5$var$animate() {
    //self rotation
    $f39bf4bcdcb148e5$var$earth.rotateY(0.004);
    $f39bf4bcdcb148e5$var$moon.rotateY(0.004);
    //rotate on body
    $f39bf4bcdcb148e5$var$moonObj.rotateY(0.03);
    //label
    //labelRender.render(scene, camera);
    $f39bf4bcdcb148e5$var$renderer.render($f39bf4bcdcb148e5$var$scene, $f39bf4bcdcb148e5$var$camera);
}
$f39bf4bcdcb148e5$var$renderer.setAnimationLoop($f39bf4bcdcb148e5$var$animate);
window.addEventListener("resize", function() {
    $f39bf4bcdcb148e5$var$camera.aspect = window.innerWidth / window.innerHeight;
    $f39bf4bcdcb148e5$var$camera.updateProjectionMatrix();
    $f39bf4bcdcb148e5$var$renderer.setSize(window.innerWidth, window.innerHeight);
});
//remove
document.getElementById("dateInput").addEventListener("click", function() {
    //
    $f39bf4bcdcb148e5$var$asteroid.position.y = -1;
    $f39bf4bcdcb148e5$var$asteroid.position.x = 170;
    //meteor
    $f39bf4bcdcb148e5$var$meteor.position.z = -11;
    $f39bf4bcdcb148e5$var$meteor.position.y = -6;
    $f39bf4bcdcb148e5$var$meteor.position.x = 170;
    //asteroid1
    $f39bf4bcdcb148e5$var$asteroid1.position.z = 10;
    //meteor1
    $f39bf4bcdcb148e5$var$meteor1.position.z = 20;
    $f39bf4bcdcb148e5$var$meteor1.position.y = 4.5;
    $f39bf4bcdcb148e5$var$meteor1.position.x = -187;
    //asteroid2
    $f39bf4bcdcb148e5$var$asteroid2.position.x = 80;
    //meteor2
    $f39bf4bcdcb148e5$var$meteor2.position.x = 80;
});


//# sourceMappingURL=hazardous-neo.72e2990d.js.map
